// Node imports
import {
  Container,
  IEvent,
  ingenuity,
  dispatcher,
  ITween,
  Linear,
  delayedCall,
  killDelayedCall,
} from "@quest/base-core";
import {
  BaseController,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-leopard/dist";
import { EventConstants as PlatformEventConstants } from "@quest/platform-murka/dist";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
// Game imports
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class BaseControllerGame extends BaseController {
  private gameReelPanelContainer: Container;
  private hintBox: Container;
  private reelcenterToLeftTween: ITween;
  private reelRightToCenterTween: ITween;
  private reelcenterToRightTween: ITween;
  private reelLeftToCenterTween: ITween;
  private reelTweenArray: ITween[] = [];

  protected subscribeEvents(): void {
    this.unsubscribeEvents();
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_STATIC_SYMBOL_BEHIND_STACK, this.hideStaticSymbol, this);
    dispatcher.on(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK, this.showStaticSymbol, this);
    dispatcher.on(eventDispatchers.SHIFT_REEL_TO_LEFT, this.slideReelFromCenterToLeft, this);
    dispatcher.on(eventDispatchers.SHIFT_REEL_TO_RIGHT, this.slideReelFromCenterToRight, this);
    dispatcher.on(eventDispatchers.HIDE_BET_CHANGE_MSG, this.hideBetChangeMsg, this);
    dispatcher.on(eventDispatchers.SHOW_BET_CHANGE_MSG, this.showBetChangeMsg, this);
  }

  protected unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.HIDE_STATIC_SYMBOL_BEHIND_STACK, this.hideStaticSymbol, this);
    dispatcher.off(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK, this.showStaticSymbol, this);
    dispatcher.off(eventDispatchers.SHIFT_REEL_TO_LEFT, this.slideReelFromCenterToLeft, this);
    dispatcher.off(eventDispatchers.SHIFT_REEL_TO_RIGHT, this.slideReelFromCenterToRight, this);
    dispatcher.off(eventDispatchers.HIDE_BET_CHANGE_MSG, this.hideBetChangeMsg, this);
    dispatcher.off(eventDispatchers.SHOW_BET_CHANGE_MSG, this.showBetChangeMsg, this);
  }
  protected initializeComponent(): void {
    super.initializeComponent();
    this.gameReelPanelContainer = this.view.getContainerByID("gameReelPanelContainer");
    this.hintBox = this.view.getContainerByID("hintBoxContainer");
  }
  /**
   * to handle initial
   */
  protected onShowBaseGame(evt: IEvent): void {
    dispatcher.fireEvent(PlatformEventConstants.UPDATE_CREDIT_VALUE);
    !ingenuity.configData.selectionScreenShowing && dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    this.updateJackpotMeters();
    this.updateBonusAmt();
    this.view.getContainerByID("buttonsContainer").visible = true;
    this.view.show();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.INITIALIZE_TOP_LOGO);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BOTTOM_BAR_VIEW);
    delayedCall("voiceSoundDelay", 600, () => {
      killDelayedCall("voiceSoundDelay");
      this.playVoiceIntroSound();
    });
    this.hideAutoplayButtons();
    this.hideTurboButtons();
    this.hideForceStopButton();
    if (ingenuity.configData.isBrokenGame) {
      this.hideBetChangeMsg();
      dispatcher.fireEvent(eventDispatchers.HANDLE_FEATURE_ON_BROKEN);
    } else {
      dispatcher.fireEvent(eventDispatchers.HANDLE_FEATURE_ON_REFRESH);
    }
    this.view.getContainerByID("portraitButtonsContainer") &&
      (this.view.getContainerByID("portraitButtonsContainer").visible = true);
  }

  //overidden to show button panels during selectionScreen

  protected onHideBaseGame(): void {
    if (!ingenuity.configData.selectionScreenShowing) {
      this.view.getContainerByID("portraitButtonsContainer") &&
        (this.view.getContainerByID("portraitButtonsContainer").visible = false);
      this.view.getContainerByID("topPortraitButtonsContainer") &&
        (this.view.getContainerByID("topPortraitButtonsContainer").visible = false);
      this.view.getContainerByID("buttonsContainer").visible = false;
    }else{
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP)
    }

    // if (ingenuity.configData.selectionScreenShowing && ingenuity.deviceEnv.isDesktop) {
    //     this.view.getContainerByID("buttonsContainer").visible = false;
    // }

    this.view.hide();
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
    killDelayedCall("baseGameBgIdleSpineDelay");
  }
  /**
   * playVoiceIntroSound method play the base game voice over sound and then continue to base game sound
   */
  private playVoiceIntroSound(): void {
    if (!(ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if (
        !(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() &&
        !gameConstants.FREEGAME_RETURN_SOUND
      ) {
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.VOICE_INTRO,
          gameConstants.VOICE_OVER_VOLUME,
          false,
          gameConstants.SOUND_LIST_PRELOAD
        );
        (ingenuity.soundManager as any).playSound(
          SoundConstant.BASEGAME_BGM_INTRO,
          1,
          false,
          gameConstants.SOUND_LIST_PRELOAD
        );
        (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO).onMarkerComplete.addOnce(() => {
          this.playBaseGameSound();
        }, this);
      } else {
        (ingenuity.soundManager as any).playSound(
          SoundConstant.BASEGAME_BGMLOOP,
          1,
          true,
          gameConstants.SOUND_LIST_PRELOAD
        );
      }
      gameConstants.FREEGAME_RETURN_SOUND = false;
    }
  }

  /**
   * playBaseGameSound method plays the base game BGM sound after voice intro
   */
  private playBaseGameSound(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGM_INTRO)) {
      (ingenuity.soundManager as any)
        .getSoundInstance(SoundConstant.BASEGAME_BGM_INTRO)
        .onMarkerComplete.addOnce(() => {
          (ingenuity.soundManager as any).playSound(
            SoundConstant.BASEGAME_BGMLOOP,
            1,
            true,
            gameConstants.SOUND_LIST_PRELOAD
          );
        }, this);
    }
  }
  /**
   * function to hide static symbol which are not taking part in win toggle
   */
  private hideStaticSymbol(evt: IEvent): void {
    const offset = this.view.getReelView().getSymbolByPos(evt.data[0] - 1, evt.data[1]);
    const staticSym = offset.getStatic();
    staticSym.visible = false;
  }
  /**
   * to show all static symbol
   */
  private showStaticSymbol(evt: IEvent): void {
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      for (let j = 0; j < ingenuity.configData.symPerReel[0]; j++) {
        const offset = this.view.getReelView().getSymbolByPos(i, j);
        const staticSym = offset.getStatic();
        staticSym.visible = true;
      }
    }
  }

  /**
   * to slide reel from center to left on Bet Plus Press Up
   */
  private slideReelFromCenterToLeft(): void {
    // dispatcher.fireEvent(eventDispatchers.HIDE_BG_LOOP_ON_BET_CHANGE);
    this.reelcenterToLeftTween = ingenuity.currentGame.add.tween(this.gameReelPanelContainer);
    this.reelTweenArray.push(this.reelcenterToLeftTween);
    this.gameReelPanelContainer.x = gameConstants.REEL_PANEL_CONTAINER_POSITION;
    this.reelcenterToLeftTween.to({ x: -1320 }, 100, Linear.None, true, 0, 0, false);
    this.reelcenterToLeftTween.onComplete.addOnce(() => {
      this.gameReelPanelContainer.visible = false;
      this.gameReelPanelContainer.x = 1320;
      this.removeMultipleTweens();
      this.slideReelFromRightToCenter();
    });
  }
  /**
   * to slide reel from right to back to the center after  slideReelFromCenterToLeft
   */
  private slideReelFromRightToCenter(): void {
    this.gameReelPanelContainer.visible = true;
    this.gameReelPanelContainer.x = 1320;
    this.reelRightToCenterTween = ingenuity.currentGame.add.tween(this.gameReelPanelContainer);
    this.reelRightToCenterTween.to(
      { x: gameConstants.REEL_PANEL_CONTAINER_POSITION },
      100,
      Linear.None,
      true,
      0,
      0,
      false
    );
    this.reelRightToCenterTween.onComplete.addOnce(() => {
      this.reelTweenArray = [];
      // dispatcher.fireEvent(eventDispatchers.SHOW_BG_LOOP_ON_BET_CHANGE);
      ingenuity.currentGame.tweens.remove(this.reelRightToCenterTween);
    });
  }
  /**
   * to slide reel from center to left on Bet Minus Press up
   */
  private slideReelFromCenterToRight(): void {
    // dispatcher.fireEvent(eventDispatchers.HIDE_BG_LOOP_ON_BET_CHANGE);
    this.reelcenterToRightTween = ingenuity.currentGame.add.tween(this.gameReelPanelContainer);
    this.reelTweenArray.push(this.reelcenterToRightTween);
    this.gameReelPanelContainer.x = gameConstants.REEL_PANEL_CONTAINER_POSITION;
    this.reelcenterToRightTween.to({ x: 1320 }, 100, Linear.None, true, 0, 0, false);
    this.reelcenterToRightTween.onComplete.addOnce(() => {
      this.gameReelPanelContainer.visible = false;
      this.gameReelPanelContainer.x = -1320;
      this.removeMultipleTweens();
      this.slideReelFromLeftToCenter();
    });
  }
  /**
   * to slide reel from left to back to the center after  slideReelFromCenterToRight
   */
  private slideReelFromLeftToCenter(): void {
    this.gameReelPanelContainer.visible = true;
    this.gameReelPanelContainer.x = -1320;
    this.reelLeftToCenterTween = ingenuity.currentGame.add.tween(this.gameReelPanelContainer);
    this.reelLeftToCenterTween.to(
      { x: gameConstants.REEL_PANEL_CONTAINER_POSITION },
      100,
      Linear.None,
      true,
      0,
      0,
      false
    );
    this.reelLeftToCenterTween.onComplete.addOnce(() => {
      this.reelTweenArray = [];
      // dispatcher.fireEvent(eventDispatchers.SHOW_BG_LOOP_ON_BET_CHANGE);
      ingenuity.currentGame.tweens.remove(this.reelLeftToCenterTween);
    });
  }
  /**
   * to remove ongoing on reel Tweens
   */
  private removeMultipleTweens(): void {
    this.reelTweenArray.forEach((tween: ITween) => {
      ingenuity.currentGame.tweens.remove(tween);
    });
  }

  // Method overrided to set balance if sum of both the balance are greater than zero
  protected updateCreditValue(evt: IEvent) {
    const balanceValue = ingenuity.parserModel.getBalance();
    const freeBalanceValue = (ingenuity.parserModel as GameParserModel).getFreeBalance();
    const totalBalance = balanceValue + freeBalanceValue;
    if (String(totalBalance) !== "NaN") {
      this.balanceMeter.setCurrencyFormattedValue(totalBalance.toFixed(2));
      dispatcher.fireEvent(EventConstantsLeander.BALANCE_UPDATED_BY_GAME, {
        balance: balanceValue,
        freeBalance: freeBalanceValue,
      });
      dispatcher.fireEvent(SlotEventConstantsBehavior.SET_BOTTOM_BAR_BALANCE, totalBalance.toFixed(2));
    }
  }
  protected onFreeGamereturning(evt: IEvent): void {
    //Do not shift below line after super() call
    this.resetDataAfterFreegame();
    super.onFreeGamereturning(evt);
  }
  /**
   * reset all data related to feature after returning freegame
   */
  private resetDataAfterFreegame(): void {
    ingenuity.configData.isReturningFromFreegame = true;
    (ingenuity.parserModel as GameParserModel).setOnionOffset([]);
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
    (ingenuity.parserModel as GameParserModel).setIsStickyWildAvailable(false);
    (ingenuity.parserModel as GameParserModel).setWildLockPos([]);
    (ingenuity.parserModel as GameParserModel).setIsFreeSpintriggered(false);
    ingenuity.configData.selectionScreenResponse = false;
  }
  /**to show game logo  */
  protected showGameLogo(): void {
    if (ingenuity.deviceEnv.isDesktop) {
      super.showGameLogo();
    }
  }
  /**
   * to hide player msg
   */
  private hideBetChangeMsg(): void {
    this.hintBox.visible = false;
    dispatcher.off(eventDispatchers.HIDE_BET_CHANGE_MSG, this.hideBetChangeMsg, this);
    dispatcher.off(eventDispatchers.SHOW_BET_CHANGE_MSG, this.showBetChangeMsg, this);
  }
  /**
   * to show player msg
   */
  private showBetChangeMsg(): void {
    this.hintBox.visible = true;
  }
}
